module.exports = __webpack_public_path__ + "img/40.a67d24b2.gif";